<div
  aria-hidden="true"
  [attr.role]="'img'"
  class="legenditem"
  id="itemmap"
  [style.width.px]="itemWidth"
  [style.height.px]="itemHeight"
></div>
